import { removeEmptyFields } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { useMutation } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { toast } from "sonner";
import axiosAuth from "../../../../axiosAuth";
import { SCHOOL_INSTALLMENTS_INVOICE_PAYMENT } from "../../../apiRoutes";
import { PaymetData } from "./useGetPaymentsByInstallmentIdQuery";

export interface UpdatePaymentResponse {
  data?: unknown;
  message?: string;
  success?: boolean;
}

export interface UpdatePaymentPayload extends PaymetData {
  invoicePaymentId: string;
}

export const useUpdatePaymentMutation = (options?: {
  onSuccess?: () => void;
}) => {
  return useMutation({
    mutationFn: async (payload: any) => {
      const { installmentId, invoicePaymentId, ...data } = payload;

      if (invoicePaymentId) {
        const {
          paidAmount,
          paidDate,
          paymentStatus,
          ...updateData
        } = data;

        const response = await axiosAuth.put(
          `${SCHOOL_INSTALLMENTS_INVOICE_PAYMENT}/${invoicePaymentId}`,
          { ...updateData, invoicePaymentId }
        );
        return response.data;
      } else {
        const response = await axiosAuth.post(
          `${SCHOOL_INSTALLMENTS_INVOICE_PAYMENT}`,
          removeEmptyFields(payload)
        );
        return response.data;
      }
    },
    onSuccess: () => {
      toast.success("Payment details saved successfully");
      options?.onSuccess?.();
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.issues?.message ||
        error?.response?.data?.issues?.error ||
        error?.response?.data?.message ||
        "Failed to save Payment details";
      toast.error(message);
    },
  });
};
